/* Söktermer (custom.search_terms) in the site search.
   Shopify's search never looks in metafields, so the theme matches them itself. The index
   comes from /collections/all?view=search-terms (templates/collection.search-terms.liquid)
   and is fetched once, on the first search of the page.
   window.sdaSearchTerms.match(query) -> Promise of product handles, best first.
   Used by the search overlay (assets/theme.js) and the results page (sections/search.liquid). */
(function () {
  var MARKS = new RegExp('[' + String.fromCharCode(768) + '-' + String.fromCharCode(879) + ']', 'g');
  function fold(v) {
    return String(v || '').toLowerCase().normalize('NFD').replace(MARKS, '').replace(/\s+/g, ' ').trim();
  }

  var index = null;
  function load() {
    if (!index) {
      index = fetch('/collections/all?view=search-terms', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : '[]'; })
        .then(function (text) {
          var rows = [];
          try { rows = JSON.parse(text); } catch (e) { rows = []; }
          return rows.filter(Boolean).map(function (row) {
            return { h: row.h, t: (row.t || []).map(fold).filter(Boolean) };
          });
        })
        .catch(function () { return []; });
    }
    return index;
  }

  // A product matches when the query starts a word in one of its terms ("klåd" finds
  // "klåda", "hud" finds "torr hud"), or when a whole term appears in the query
  // ("klåda hos hund" finds "klåda"). Products with an exact term come first.
  function match(query) {
    var q = fold(query);
    if (q.length < 2) return Promise.resolve([]);
    var padded = ' ' + q + ' ';
    return load().then(function (rows) {
      var exact = [];
      var other = [];
      rows.forEach(function (row) {
        var hit = 0;
        row.t.forEach(function (t) {
          if (t === q) {
            hit = 2;
          } else if (!hit && ((' ' + t).indexOf(' ' + q) > -1 || (t.length > 2 && padded.indexOf(' ' + t + ' ') > -1))) {
            hit = 1;
          }
        });
        if (hit === 2) exact.push(row.h);
        else if (hit === 1) other.push(row.h);
      });
      return exact.concat(other);
    });
  }

  window.sdaSearchTerms = { match: match, load: load };
})();
